module.exports = __webpack_public_path__ + "img/instagram.f3ff4d62.svg";